import React, { useState, useEffect } from "react";
import CarCard from "./CarCard";
import { Result } from "antd";
import CarModal from "../../components/CarModal/CarModal";
import Api from "../../network/ApiConfig";

export default function FavList() {
  const [CarSearchLoading, setCarSearchLoading] = useState(false);
  const [CarSearchList, setCarSearchList] = useState([]);
  const [detailsModal, setDetailsModal] = useState(false);

  useEffect(() => {
    handelGetSearchData();
  }, []);

  const handelGetSearchData = (pageIndex) => {
    setCarSearchLoading(true);
    Api.get("WishLists/GetMyWishList?Page=0").then(
      (res) => {
        setCarSearchLoading(false);
        if (res?.status === 200) {
          console.log(res?.data, "res?.data");
          setCarSearchList(res?.data?.model || []);
        }
        // setCarSearch();
      },
      (err) => {
        setCarSearchLoading(false);
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
  };
  return (
    <div className="cars-search-holder">
      <div className="cars-search-grid">
        {(CarSearchLoading
          ? { Data: [1, 2, 3, 4, 5, 6] }
          : CarSearchList
        )?.Data?.map((car) => (
          <CarCard
            CarSearchLoading={CarSearchLoading}
            setDetailsModal={setDetailsModal}
            car={car}
          />
        ))}
      </div>
      {!CarSearchLoading && !CarSearchList?.Data?.length && (
        <Result status={404} title="لا يوجد سيارات" />
      )}
      <CarModal
        mainData={detailsModal}
        open={detailsModal}
        setOpen={setDetailsModal}
      />
    </div>
  );
}
